import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { createRole, resetFilters } from "../redux/rolesSagas";
import { Filters } from "./Filters";
import { MainModal } from "../../../../components/modal/MainModal";
import { ErrorList } from "../../../../components/ErrorList";

export const Add = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();

  const {
    selected: { name, identifier, organization },
    status,
    errors
  } = useSelector((state) => state.roles);

  const save = () => {
    dispatch(createRole());
  };

  const close = () => {
    dispatch(resetFilters());
    onClose();
  };

  useEffect(() => {
    if (status == "success") {
      close();
    }
  }, [status]);

  const primaryButtonDisabled = !(
    organization &&
    name &&
    name.trim() &&
    identifier &&
    identifier.trim()
  );

  return (
    <>
      <MainModal
        isOpen={isOpen}
        onClose={close}
        parentSelector=".roles"
        headerText="Add Role"
        headerCloseHandler={close}
        bodyClassName="main-popup-body"
        primaryButtonText="Save"
        primaryButtonDisabled={primaryButtonDisabled}
        primaryBtnHandler={() => save()}
        secondaryBtnText="Cancel"
        secondaryBtnHandler={close}
        height={300}
        width={900}
      >
        <Filters />
        <ErrorList errors={errors} />
      </MainModal>
    </>
  );
};
